import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "../SessionContext";

export const ProtectedRoute = () => {
  const session = useSession();
  const location = useLocation();

  if (!session) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
